const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  useMocks: process.env.REACT_APP_USE_MOCKS === 'true',
};

export default config;
